<div class="off-canvas-content">
  <div class="offCanvas__container">
    <div class="offCanvas__contentWrapper">
      @if (!isFileView) {
        <div class="offCanvas__header">
          <div class="offCanvas__title">
            Send Email
          </div>
          <img (click)="onCloseIconClick()" class="offCanvas__crossIcon"
            src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
          </div>
        }

        <form class="mt-3" [formGroup]="sentEmailFormGroup">
          <div class="offcanvas__content">
            <div class="offcanvas__orgDetails">
              <div class="offCanvas__orgName-inputField">
                <div class="form-group">
                  <label for="selectOption" class="filterOffcanvas__inputlabel">
                    To<span style="color: chocolate;">*</span></label>
                    <div class="d-flex justify-content-start gap-2_adddropdown">
                      <div  class="form-control form-select filterOffcanvas__inputlabel">
                        <div (mouseleave)="showDropDown = false">
                          <button class="drop-toggle btn flat" (click)="showDropdown()">
                            @if (checkedMultiList.length<=0) {
                              <span class="spancolor">
                              Select Email</span>
                            }
                            @if (checkedMultiList.length>0) {
                              <span class="spancolor">{{checkedMultiList.join(', ')}}</span>
                            }
                            @if (checkedMultiList.length>0) {
                              <small (click)="closeItem()" class="close-icon btn-close" aria-label="close"></small>
                            }
                          </button>
                          @if (showDropDown) {
                            <div class="drop-show">
                              <div class="usersFilter__branchesField">
                                <div class="usersFilter__branchWrappar">
                                  <img class="usersFilter__searchIcon"
                                    src="../../../../assets/Images/user-management/searchIcon.svg" alt="search"  />
                                    <input (input)="handleFilter($event)" class="usersFilter__input" [formControl]="searchControl"
                                      placeholder="Search"/>
                                    </div>
                                  </div>
                                  @if (showEmailIcon) {
                                    <div class="createPackage__InviteUser"
                                      (click)="addItem(searchControl.value)">
                                      <img src="../../../../assets/Images/create-package/Addor.svg" alt="add" />
                                      Add External Email
                                    </div>
                                  }
                                  @for (item of emailSearchList; track item) {
                                    <div  class="email-list-item">
                                      <app-checkbox checkboxStatus="{{item.checked}}"
                                      (checked)="selectEmail($event.event.target.checked, item)"></app-checkbox>
                                      <span>{{item.emailAddress}}</span>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (sentEmailFormGroup.controls?.['to']?.invalid &&
                        (sentEmailFormGroup.controls?.['to']?.dirty ||
                        sentEmailFormGroup.controls?.['to']?.touched)) {
                        <div class="alert_required">
                          @if (sentEmailFormGroup.controls?.['to']?.errors?.['required']) {
                            <div>
                              <small class="text-danger">Email is required.</small>
                            </div>
                          }
                          @if (sentEmailFormGroup.controls?.['to']?.errors?.['pattern']) {
                            <div>
                              <small class="text-danger">Please enter a valid email address.</small>
                            </div>
                          }
                        </div>
                      }
                    </div>

                    <div class="offCanvas__orgName-inputField">
                      <app-input-filed label="Subject" placeholder="Subject"
                        [control]="$any(sentEmailFormGroup).controls['subject']"
                      [starIcon]="'*'"></app-input-filed>
                      @if (sentEmailFormGroup.controls?.['subject']?.invalid &&
                        (sentEmailFormGroup.controls?.['subject']?.dirty ||
                        sentEmailFormGroup.controls?.['subject']?.touched)) {
                        <div class="alert_required">
                          @if (sentEmailFormGroup.controls?.['subject']?.errors?.['required']) {
                            <div>
                              <small class="text-danger">Subject is required.</small>
                            </div>
                          }
                        </div>
                      }
                    </div>

                    <div class="offCanvas__orgName-inputField">
                      <app-description-field DescriptionData="Description"
                        [control]="$any(sentEmailFormGroup).controls['description']"
                      placeholder="Description"></app-description-field>
                    </div>

                    @if (!isFileView) {
                      <div>
                        <section class="editDocument__document">
                          <div class="editDocument__header">
                            @if (envType == appType.sdex) {
                              <div class="editDocument__fileInfo" data-bs-toggle="tooltip"
                                [ngbTooltip]="largeFileName(selectedFile?.customFileName? selectedFile?.customFileName: selectedFile?.name, '')"
                                placement="top">
                                <p class="editDocument__filename">{{largeFileName(selectedFile?.customFileName ? selectedFile?.customFileName :
                                selectedFile?.name, 'file')}} </p>
                              </div>
                            }
                            @if (envType == appType.dams) {
                              <div class="editDocument__fileInfo" data-bs-toggle="tooltip"
                                [ngbTooltip]="largeFileName(selectedFile?.documentNumber? selectedFile?.documentNumber: selectedFile?.name, '')"
                                placement="top">
                                <p class="editDocument__filename">{{largeFileName(selectedFile?.documentNumber ? selectedFile?.documentNumber :
                                selectedFile?.name, 'file')}} </p>
                              </div>
                            }
                          </div>
                          <div class="editDocument__image">
                            @if (!selectedFile?.thumbnailUrl) {
                              <img src="../../../assets/Images/document-preview/Files.svg"
                                alt="" [width]="230" [height]="133"/>
                            }
                            @if (selectedFile?.thumbnailUrl) {
                              <img [src]="selectedFile?.thumbnailUrl" alt="" [width]="230"
                                [height]="133"/>
                            }
                          </div>
                        </section>
                      </div>
                    }


                    <small class="text-danger">{{errorMessage}}</small>
                  </div>
                </div>
              </form>
            </div>

            <div class="offCanvas__footer">
              <app-common-button (clickEvent)="onCloseIconClick()" buttonClass="smallbutton"
              buttonLabel="Cancel"></app-common-button>

              <app-common-button (clickEvent)="triggerMail()" buttonClass="smallFilledButton" buttonLabel="Send"
              [loadingIcon]="verifyLoader" [disabled]="sentEmailFormGroup.invalid || !checkedMultiList.length"></app-common-button>
            </div>
          </div>

          @if (isToster) {
            <app-error-toaster (closeToaster)="closeToster($event)"  [title]="message"></app-error-toaster>
          }